import React from 'react';
import { LazyMotion } from 'framer-motion';
var loadFeatures = function () {
    return import('./motion-features.js').then(function (res) { return res["default"]; });
};
export var MotionWrapper = function (_a) {
    var children = _a.children;
    return (React.createElement(LazyMotion, { strict: true, features: loadFeatures }, children));
};
